import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section id="garantia" className="py-10 sm:py-16 lg:py-20 bg-navy-900" data-id="element-121">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy-800 border border-navy-700 rounded-3xl p-6 sm:p-8 md:p-12 text-center relative overflow-hidden" data-id="element-123">
          {/* Background decoration */}
          <div className="absolute -top-16 -right-16 sm:-top-24 sm:-right-24 w-32 h-32 sm:w-48 sm:h-48 bg-green-500/10 rounded-full blur-2xl sm:blur-3xl" data-id="element-124" />
          <div className="absolute -bottom-16 -left-16 sm:-bottom-24 sm:-left-24 w-32 h-32 sm:w-48 sm:h-48 bg-gold-500/10 rounded-full blur-2xl sm:blur-3xl" data-id="element-125" />

          <div className="relative z-10" data-id="element-126">
            <motion.div animate={{
            y: [-3, 3, -3]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} className="inline-flex items-center justify-center p-3 sm:p-4 bg-navy-900 rounded-full mb-4 sm:mb-6 border border-navy-700 shadow-lg" data-id="element-127">
              <ShieldCheckIcon className="w-8 h-8 sm:w-12 sm:h-12 text-green-500" data-id="element-128" />
            </motion.div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-display text-offwhite uppercase mb-2 sm:mb-4" data-id="element-129">
              7 DÍAS: <span className="text-gold-500" data-id="element-130">GARANTÍA TOTAL</span>
            </h2>

            <p className="text-base sm:text-lg md:text-xl text-offwhite font-medium mb-4 sm:mb-6" data-id="element-131">
              7 días para probarlo o te devolvemos el 100%
            </p>

            <p className="text-xs sm:text-sm md:text-base text-text-secondary leading-relaxed mb-4 sm:mb-6" data-id="element-132">
              Descargás los tomos, usás los bonos en tu próximo entrenamiento en
              el club. Si no sientes que tu técnica es más limpia y
              estructurada: sin preguntas, sin formularios, sin drama.
            </p>

            <div className="inline-block bg-navy-900 border border-navy-700 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-semibold text-text-secondary" data-id="element-133">
              Tasa de devoluciones {'<'} 1%
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}